// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__k-5gU","col":"styles_col__XKjFd","fulfillmentStatus":"styles_fulfillmentStatus__3j9Sn","emailCol":"styles_emailCol__2Ebq_"};